import React from 'react';

export const Send = React.memo(
  ({
    fill
  }) => (
    <path
      d={'M24.9557 5.85725C25.0011 5.74367 25.0123 5.61924 24.9877 5.4994C24.9631 5.37956 24.9039 5.26956 24.8174 5.18306C24.7309 5.09655 24.6209 5.03733 24.501 5.01275C24.3812 4.98817 24.2568 4.99929 24.1432 5.04476L5.95968 12.3184H5.95843L5.39343 12.5434C5.28642 12.5861 5.19329 12.6575 5.12433 12.7498C5.05537 12.8421 5.01326 12.9517 5.00265 13.0664C4.99205 13.1811 5.01336 13.2965 5.06423 13.3999C5.11511 13.5033 5.19356 13.5906 5.29093 13.6521L5.80343 13.9771L5.80468 13.9796L12.0483 17.9521L16.0208 24.1958L16.0233 24.1983L16.3483 24.7108C16.4101 24.8078 16.4974 24.8858 16.6007 24.9364C16.704 24.9869 16.8192 25.008 16.9337 24.9973C17.0482 24.9866 17.1576 24.9444 17.2497 24.8756C17.3418 24.8067 17.4131 24.7138 17.4558 24.607L24.9557 5.85725ZM22.6645 8.21972L13.2971 17.5871L13.0283 17.1646C12.9791 17.0871 12.9134 17.0213 12.8358 16.9721L12.4133 16.7034L21.7807 7.33598L23.2532 6.74724L22.6657 8.21972H22.6645Z'}
      fill={fill}/>
  ),
);
Send.displayName = 'Send';

